export const MenuItems = [
    { title: 'Home', url: '#', cName: 'nav-links' },
    { title: 'Services', url: '#', cName: 'nav-links' },
    { title: 'Portfolio', url: '#', cName: 'nav-links' },
    { title: 'Blogs', url: '#', cName: 'nav-links' },
    { title: 'Contact Us', url: '#', cName: 'nav-links' }
];